export function determineUseActualMOT(type, appointments, complete) {
  let useActualMOT = true;

  if (
    type !== 'Installation' ||
    !Array.isArray(appointments) ||
    !appointments.length ||
    complete
  ) {
    return useActualMOT;
  }

  appointments.forEach((appointment) => {
    if (appointment.kind === 'installation' || appointment.kind === 'installation_hold') {
      useActualMOT = false;
    }
  });

  return useActualMOT;
}

export function determineComplete(phaseStatus, phaseTasks) {
  if (phaseStatus === 'canceled' || phaseStatus === 'completed') return true;

  let complete = false;
  if (Array.isArray(phaseTasks) && phaseTasks.length) {
    phaseTasks.forEach((phaseTask) => {
      if (
        ['install_complete', 'workorder_complete', 'measure'].includes(phaseTask.slug)
        && phaseTask.status === 'complete'
      ) {
        complete = true;
      }
    });
  }
  return complete;
}

export function determineMOTTitle(type, useActualMOT, complete = false) {
  let motTitle = 'Projected MOT';

  if (type !== 'Installation') {
    motTitle = 'MOT';
  } else if (complete) {
    motTitle = 'Actual MOT';
  } else if (useActualMOT) {
    motTitle = 'Current MOT';
  }

  return motTitle;
}

export function determineMOTColorCode(
  phase,
  useActualMOT,
  complete = false,
  assessmentDue = '',
) {
  const limit = phase.product_type === 'STK' ? 21 : 28;
  const mot = useActualMOT ? phase.actual_mot : phase.projected_mot;

  if (!mot) { return 'motNotApplicable'; }

  if (
    useActualMOT &&
    !complete &&
    mot >= 3 &&
    assessmentDue.toLowerCase() === 'assessment_due'
  ) {
    return 'motWarningAssessmentDue';
  }

  if (
    useActualMOT &&
    !complete &&
    mot >= 3
  ) {
    return 'motWarning';
  }

  return mot <= limit ? 'motOnTime' : 'motOverdue';
}

export function determineMOT(phase, useActualMOT) {
  let mot = 'N/A';

  if (useActualMOT) {
    mot = phase.actual_mot ? `${phase.actual_mot} Days` : mot;
  } else {
    mot = phase.projected_mot ? `${phase.projected_mot} Days` : mot;
  }

  return mot;
}



// WEBPACK FOOTER //
// ./client/app/utils/motUtils.js